import { Network } from '@capacitor/network'

export default ({
  namespaced: true,
  state: {
    isOnline: true,
    isRequestFailed: false,
  },
  mutations: {
    SET_ONLINE(state, value) {
      state.isOnline = value;
    },
    SET_IS_REQUEST_FAILED(state, value) {
      state.isRequestFailed = value;
    },
  },
  actions: {
    async init({ commit }) {
      const status = await Network.getStatus()
      commit('SET_ONLINE', status.connected)
      //console.log('jalan init')

      Network.addListener('networkStatusChange', (status) => {
        commit('SET_ONLINE', status.connected)
      })
    },
    async checkConnection({ commit, state }) {
      const status = await Network.getStatus()
      //console.log('isOnline', state.isOnline)
      commit('SET_ONLINE', status.connected)
    }
  }
})
